export default {"src":"/_next/static/media/clone.09e979cd.svg","height":512,"width":512};